const menu = document.querySelector(".navbar-menu");
const menuBtn = document.querySelector(".mobile-menu-btn");
const mainNav = document.getElementById("nav-main");
const subMenu = document.querySelectorAll(".sub-menu");
const hasSub = document.querySelectorAll("li.has-sub");
const toggleBtn = document.querySelectorAll(".toggle-btn");
const overlayMobile = document.querySelector(".overlay-mobile");
const overlayDesktop = document.querySelector(".overlay-desktop");
const header = document.querySelector('header');

function isJobSearch() {
  if (document.body.classList.contains('job-search')) {
    return true;
  }
}

const toggleMenu = () => {
  menuBtn.classList.toggle("active");
  menu.classList.toggle("open");
  overlayMobile.classList.toggle("open");

  if (isJobSearch()) {
    header.style.position = menu.classList.contains("open") ? "fixed" : "";
  }

  if (!menu.classList.contains("open")) {
    overlayMobile.classList.remove("open");
  }
};

const closeMenu = () => {
  menuBtn.classList.remove("active");
  menu.classList.remove("open");
  overlayMobile.classList.remove("open");
  subMenu.forEach((menu) => {
    if (menu.classList.contains("open")) {
      menu.classList.remove("open");
      menu.style.height = "0px";
    }
  });
  hasSub.forEach((li) => {
    if (li.classList.contains("open")) {
      li.classList.remove("open");
    }
  });
  toggleBtn.forEach((btn) => {
    if (btn.classList.contains("open")) {
      btn.classList.remove("open");
      btn.previousElementSibling.style.color = "#2f3233";
      btn.previousElementSibling.style.textDecoration = "none";
    }
  });
};

subMenu.forEach((menu) => (menu.style.height = "0px"));

toggleBtn.forEach((btn) => {
  btn.addEventListener("click", function (e) {
    this.classList.toggle("open");

    const sub = this.nextElementSibling;
    sub.classList.toggle("open");
    sub.style.height = "0px";

    if (this.classList.contains("open")) {
      sub.style.height = "auto";
      this.previousElementSibling.style.color = "#00695F";
      this.previousElementSibling.style.textDecoration = "underline";

      let height = sub.clientHeight + "px";

      setTimeout(() => {
        sub.style.height = height;
      }, 0);
    } else {
      this.previousElementSibling.style.color = "#2f3233";
      this.previousElementSibling.style.textDecoration = "none";
    }
  });
});

const showDesktopOverlay = () => {
  if (window.innerWidth >= 1024) {
    hasSub.forEach((sub) => {
      sub.addEventListener("mouseover", () => {
        overlayDesktop.classList.add("open");
      });
      sub.addEventListener("mouseout", () => {
        overlayDesktop.classList.remove("open");
      });
    });
  }
};
showDesktopOverlay();

document.addEventListener("keyup", (e) => {
  if (e.key === "Escape") closeMenu();
});

menuBtn.addEventListener("click", toggleMenu);
overlayMobile.addEventListener("click", closeMenu);

// Always fire closeMenu() at 1024px breakpoint
const mq = window.matchMedia("screen and (min-width: 1024px)");

mq.addEventListener("change", (event) => {
  if (event.matches) {
    closeMenu();
    showDesktopOverlay();
  }
});
